import React, { useState } from 'react';

import '../../../libs/bulma.min.css';

import { sendPingAndTracertSystem } from '../../../services';

function CommandPage() {
  const [command, setCommand] = useState('ping');
  const [ip, setIp] = useState('8.8.8.8');
  const [log, setLog] = useState('');
  const [isRunning, setIsRunning] = useState(false);

  const startCommand = async () => {
    setLog('');
    setIsRunning(true);

    try {
      const response = await sendPingAndTracertSystem({ ip, command });
      
      if (!response.body) {
        throw new Error('Seu navegador não suporta streaming.');
      }
      
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let done = false;

      while (!done) {
        const { value, done: doneReading } = await reader.read();
        done = doneReading;
        if (value) {
          setLog((prev) => prev + decoder.decode(value));
        }
      }
    } catch (error) {
      setLog(`Erro: ${error.message}`);
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <div>      
      <div className="columns mt-3">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <strong className="is-size-3">VIGOSCLOUD CONECTIVIDADE</strong>
          <hr className="dropdown-divider"/>
        </div>
      </div>
      <div className="container" style={{ padding: '20px' }}>
        <div className="columns">
          <div className="column">
            <div className="field">
              <label className="label">Comando</label>
              <div className="control">
                <div className="select is-fullwidth">
                  <select
                    value={command}
                    onChange={(e) => setCommand(e.target.value)}
                  >
                    <option value="ping">Ping</option>
                    <option value="traceroute">Traceroute</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="column">
            <div className="field">
              <label className="label">IP</label>
              <div className="control">
                <input
                  className="input"
                  type="text"
                  value={ip}
                  onChange={(e) => setIp(e.target.value)}
                  placeholder="Digite o IP..."
                />
              </div>
            </div>
          </div>
        </div>
        <div className="field">
          <div className="control">
            <button
              className={`button is-link ${isRunning ? 'is-loading' : ''} is-fullwidth`}
              onClick={startCommand}
              disabled={isRunning}
            >
              {isRunning ? 'Executando...' : 'Executar Comando'}
            </button>
          </div>
        </div>
        <div className="box has-background-light" style={{ marginTop: '20px', whiteSpace: 'pre-wrap' }}>
          {log}
        </div>
      </div>
    </div>
  );
}

export default CommandPage;
